import { Stack } from "prism-react";
import * as React from "react";

import { AnimatedDiv } from "./AnimatedDiv";
import type { EditorTypeProps } from "./EditorType";
import { EditorType } from "./EditorType";

export const TitleUI: React.FC<
  React.PropsWithChildren<{
    type: EditorTypeProps;
  }>
> = ({ children, type }) => {
  return (
    <Stack
      css={{
        px: "$10",
        alignItems: "center",
        height: 32,
        color: "$neutral-fg-subtle",

        "button, a, svg": {
          fontWeight: "$regular",
        },

        // We need the affordances but not the variants styles
        "button:disabled": {
          cursor: "initial",
          opacity: 1,
        },

        "button:not([disabled]), a:not([disabled])": {
          "&:active": {
            borderColor: "transparent",
          },
        },
      }}
      horizontal
      selectable
    >
      <Stack css={{ width: "100%" }} gap={1} horizontal>
        <AnimatedDiv
          css={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <EditorType type={type} />
        </AnimatedDiv>

        <Stack gap={0} horizontal>
          {children}
        </Stack>
      </Stack>
    </Stack>
  );
};
